import { render, staticRenderFns } from "./ServiceAreasDashboardOverview.vue?vue&type=template&id=bb481844&scoped=true&"
import script from "./ServiceAreasDashboardOverview.vue?vue&type=script&lang=js&"
export * from "./ServiceAreasDashboardOverview.vue?vue&type=script&lang=js&"
import style0 from "./ServiceAreasDashboardOverview.vue?vue&type=style&index=0&id=bb481844&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "bb481844",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("C:\\Users\\Kevin\\Documents\\source\\locate2u-server\\Locate2u.AppPortal\\node_modules\\vue-hot-reload-api\\dist\\index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('bb481844')) {
      api.createRecord('bb481844', component.options)
    } else {
      api.reload('bb481844', component.options)
    }
    module.hot.accept("./ServiceAreasDashboardOverview.vue?vue&type=template&id=bb481844&scoped=true&", function () {
      api.rerender('bb481844', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/pages/TeamSettings/ServiceAreas/Dashboard/ServiceAreasDashboardOverview.vue"
export default component.exports